import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  SafeAreaView,
  Platform,
} from 'react-native';
import { COLORS } from '../constants/theme';

interface WelcomeScreenProps {
  onLoginPress: () => void;
}

export const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onLoginPress }) => {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.contentContainer}>
        <Image source={require('../../assets/images/business-arrow-growing-up.png')} style={styles.welcomeImage} />
        <Text style={styles.title}>
          Welcome to <Text style={styles.appNameHighlight}>Lifecycle</Text>
        </Text>
        <Text style={styles.description}>
          {`Track the performance of your
investments and stay informed about
upcoming events.
Easily access the details of your products.`}
        </Text>
        <TouchableOpacity
          style={styles.loginButton}
          onPress={onLoginPress}
          activeOpacity={0.8}
        >
          <Text style={styles.loginButtonText}>Log in</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 24,
    maxWidth: 600,
    width: '100%',
    alignSelf: 'center',
  },
  welcomeImage: {
    width: '90%',
    maxWidth: 400,
    height: 240,
    marginBottom: 32,
    resizeMode: 'contain',
  },
  title: {
    fontSize: 24,
    fontWeight: '600',
    color: '#374151',
    textAlign: 'center',
    marginBottom: 16,
    fontFamily: 'Montserrat_600SemiBold',
    width: '100%',
    maxWidth: 450,
  },
  appNameHighlight: {
    color: COLORS.primary,
    fontWeight: 'bold',
    fontFamily: 'Montserrat_700Bold',
  },
  description: {
    fontSize: 15,
    color: '#6B7280',
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 40,
    fontFamily: 'Montserrat_400Regular',
    width: '100%',
    maxWidth: 450,
  },
  loginButton: {
    backgroundColor: COLORS.primary,
    paddingVertical: 16,
    borderRadius: 12,
    width: '100%',
    maxWidth: 450,
    alignItems: 'center',
  },
  loginButtonText: {
    color: '#FFFFFF',
    fontSize: 17,
    fontWeight: '600',
    fontFamily: 'Montserrat_600SemiBold',
  },
});
